<script lang="ts">
const __DsBlock = {
	type: 'display',
	name: '$t:blocks.display_color_value.name',
	description: '$t:blocks.display_color_value.description',
	category: 'display',
	hidden: true,

	fieldBinding: { supportedTypes: ['color'] },
}
</script>
<script setup lang="ts">
import type { DisplayBlockProps } from '#layers/blocks/types/display-block';

import { defineBlock } from '#layers/block-engine/public';

export interface DisplayColorValueProps extends DisplayBlockProps<string> {}

defineProps<DisplayColorValueProps>();

;
</script>

<template>
	<DDisplayValueEmpty v-if="value === null || value === undefined" />
	<DTooltip v-else :text="value">
		<DColorDot :color="value" size="sm" />
	</DTooltip>
</template>
